import { deviceTypes } from 'z-js-commons';

export default {
    info: {
        title: 'CERCA TRA GLI ESERCIZI INVALSI',
        description:
            'Trovi gli esercizi ufficiali dati alle prove INVALSI. Scrivi nel campo di ricerca: ti saranno suggeriti tutti gli argomenti che hanno esercizi associati. Raffina la tua ricerca con gli altri filtri.',
        name: 'InvalsiExercisesSearchForm',
        tutorialName: 'crea-verifica_tab-INVALSI'
    },
    [deviceTypes.DESKTOP]: {
        popoverPlacement: 'right',
        xPlacement: 'RIGHT',
        yPlacement: 'MIDDLE',
        xOffset: -5,
        yOffset: 3
    },
    [deviceTypes.PHONE]: {
        popoverPlacement: 'bottom',
        xPlacement: 'LEFT',
        yPlacement: 'MIDDLE',
        xOffset: 10,
        yOffset: 3
    }
};
